var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 1.81006L12.27 4.64006C11.5 5.42006 11.5 6.69006 12.27 7.47006L13.68 8.88006L9.13001 13.4301L6.31001 10.6001L4.89001 12.0001C-0.0599859 17.0001 3.50001 20.5001 3.50001 20.5001C3.50001 20.5001 7.00001 24.0001 12 19.0901L13.41 17.6801L10.61 14.8801L15.15 10.3401L16.54 11.7301C17.32 12.5001 18.59 12.5001 19.37 11.7301L22.2 8.90006L15.1 1.81006ZM17.93 10.2801L16.55 8.90006L15.11 7.46006L13.71 6.06006L15.12 4.65006L19.35 8.88006L17.93 10.2801Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.f09b348488620e5dc5a5178db19b9b39.svg";
export { ForwardRef as ReactComponent };